import legal from './legal';
import wizard from './wizard';

export default [
    legal,
    wizard
];
